var TAG_TOGGLE_SELECTOR = '.tag-toggle-component';
var LIST_EXPANDED_CLASS = 'tag-toggle-component__list--expanded';
var INIT_ATTRIBUTE = 'data-tag-toggle-initialized';
var LIST_ID_PREFIX = 'tag-toggle-list-';
var listIdCounter = 0;

function getListId(list) {
  if (list.id) return list.id;

  listIdCounter += 1;
  list.id = LIST_ID_PREFIX + listIdCounter;

  return list.id;
}

function listOverflows(list) {
  var lastItem = list.lastElementChild;
  if (!lastItem) return false;
  var listRect = list.getBoundingClientRect();
  var itemRect = lastItem.getBoundingClientRect();
  return Math.round(itemRect.right) > Math.round(listRect.right);
}

export function initTagToggle(container) {
  if (!container || container.getAttribute(INIT_ATTRIBUTE) === 'true') return;

  var list = container.querySelector('.tag-toggle-component__list');
  var btn = container.querySelector('.tag-toggle-component__button');
  if (!list || !btn) return;

  var label = btn.querySelector('.tag-toggle-component__button-label');
  if (!label) {
    label = document.createElement('span');
    label.className = 'tag-toggle-component__button-label';

    Array.from(btn.childNodes).forEach(function (node) {
      if (node === label) return;
      if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'UXT-ICON') return;
      label.appendChild(node);
    });

    btn.appendChild(label);
  }

  btn.setAttribute('aria-controls', getListId(list));
  list.removeAttribute('aria-expanded');

  function setExpandedState(expanded) {
    list.classList.toggle(LIST_EXPANDED_CLASS, expanded);
    list.classList.toggle('overflow-hidden', !expanded);
    label.textContent = expanded ? 'Less' : 'More';
    btn.setAttribute('aria-expanded', String(expanded));
  }

  function updateButtonVisibility() {
    var isExpanded = list.classList.contains(LIST_EXPANDED_CLASS);

    // Temporarily collapse the list for accurate single-line measurement
    if (isExpanded) {
      list.classList.remove(LIST_EXPANDED_CLASS);
      list.classList.add('overflow-hidden');
    }

    // Hide the button so the list gets full available width for measurement
    btn.classList.add('d-none');
    var shouldShowButton = listOverflows(list);

    // Restore expanded state if it was expanded
    if (isExpanded) {
      list.classList.add(LIST_EXPANDED_CLASS);
      list.classList.remove('overflow-hidden');
    }

    btn.classList.toggle('d-none', !shouldShowButton);

    if (!shouldShowButton) {
      setExpandedState(false);
    }
  }

  container.setAttribute(INIT_ATTRIBUTE, 'true');
  setExpandedState(list.classList.contains(LIST_EXPANDED_CLASS));
  updateButtonVisibility();

  btn.addEventListener('click', function () {
    setExpandedState(!list.classList.contains(LIST_EXPANDED_CLASS));
    updateButtonVisibility();
  });

  window.addEventListener('resize', updateButtonVisibility);
}

export function initTagToggles(root = document) {
  if (!root || !root.querySelectorAll) return;

  root.querySelectorAll(TAG_TOGGLE_SELECTOR).forEach(function (container) {
    initTagToggle(container);
  });
}

function bootstrapTagToggles() {
  initTagToggles(document);
  window.setTimeout(initTagToggles, 0);
  window.setTimeout(initTagToggles, 250);
  window.setTimeout(initTagToggles, 1000);
}

if (typeof window !== 'undefined') {
  window.initTagToggles = initTagToggles;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrapTagToggles);
  } else {
    bootstrapTagToggles();
  }

  window.addEventListener('load', bootstrapTagToggles);
}

export default initTagToggles;
